import { APPROVAL_LIST, ACCEPT, REJECT } from "./type";

const initalState = {
    approvalList: {},
    accept: [],
    reject: []
};

const locationApprovalReducer = (state = initalState, action) => {
    const { type, payload } = action;
    switch (type) {
        case APPROVAL_LIST:
            return {
                ...state,
                approvalList: payload,
            };
        case ACCEPT:
            return {
                ...state,
                accept: payload,
            };
        case REJECT:
            return {
                ...state,
                reject: payload,
            };
        default:
            return {
                ...state,
            };
    }
};

export default locationApprovalReducer;
